import { render, staticRenderFns } from "./auth-set-password.vue?vue&type=template&id=39552546&scoped=true&lang=pug"
import script from "./auth-set-password.js?vue&type=script&lang=js&external"
export * from "./auth-set-password.js?vue&type=script&lang=js&external"
import style0 from "./auth-set-password.vue?vue&type=style&index=0&id=39552546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39552546",
  null
  
)

export default component.exports